import service from './../service.js';

export default {
    authenticate(qr) {
        return service.post('/member/' + qr + '/authenticate');
    }
}